module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_13.f778e203.jpg";